import { FC } from 'react';
import ServicesFeaturesItem from './ServicesFeaturesItem';
import { ServicesFeaturesType } from '@/types';

interface IServicesFeatureProps {
  servicesFeatures: ServicesFeaturesType[];
}

const ServicesFeature: FC<IServicesFeatureProps> = ({ servicesFeatures }) => {
  return (
    <>
      <ul className={'card-set [--card-gap:80px]'}>
        {servicesFeatures.map(
          ({
            sfId,
            sfIdText,
            sfBackground,
            sfIcon,
            sfTittle,
            sfText,
            sfFeature,
            sfButtonText,
            sfLink,
            sfAriaLabel,
          }: ServicesFeaturesType) => (
            <li key={sfId} className={' card-set-item '}>
              <ServicesFeaturesItem
                sfIdText={sfIdText}
                sfBackground={sfBackground}
                sfIcon={sfIcon}
                sfTittle={sfTittle}
                sfText={sfText}
                sfFeature={sfFeature}
                sfButtonText={sfButtonText}
                sfLink={sfLink}
                sfAriaLabel={sfAriaLabel}
              />
            </li>
          )
        )}
      </ul>
    </>
  );
};

export default ServicesFeature;
